import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VendorUtilService {

  style(props :any) {
    let testee = document.createElement('span');
    for (let i = 0, l = props.length; i < l; ++i) {
      if (typeof testee.style[props[i]] !== 'undefined') {
        return props[i]
      }
    }
    return props[0]
  }
}
